import Box from '@mui/material/Box';
import { element } from 'prop-types';
import React from 'react';

const styles = {
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: '10px',
  },
};

const SectionBody = ({ children }) => <Box sx={styles.root}>{children}</Box>;

SectionBody.propTypes = {
  children: element.isRequired,
};

export default SectionBody;
